const isDevelop =
	window.location.hostname.includes('test') ||
	window.location.hostname.includes('localhost')

export const AUTH_API_URL = isDevelop
	? 'https://test.asterx.kz/api-auth'
	: 'https://asterx.kz/api-auth'

export const CAR_API_URL = isDevelop
	? 'https://test.asterx.kz/api-car'
	: 'https://asterx.kz/api-car'

export const SUB_API_URL = isDevelop
	? 'https://test.asterx.kz'
	: 'https://asterx.kz'
